import '../App.css';
import  AsciiRenderer from './AsciiRenderer';
import * as THREE from 'three';
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'


function Sphere1() {
  const meshRef = useRef<THREE.Mesh>(null!);
  useFrame(() => {
    const timer = Date.now();
    meshRef.current.rotation.x = timer * 0.0003;
    meshRef.current.rotation.z = timer * 0.0002;
  });

  return (
    <mesh ref={meshRef} position={[-514, 0, 0]}>
      <sphereGeometry args={[175, 32, 32]} />
      <meshPhongMaterial 
        flatShading={true}
        color={"0xcccccc"}
        shininess={100}
      />
    </mesh>
  );
}

function Sphere2() {
  const meshRef = useRef<THREE.Mesh>(null!);

  useFrame(() => {
    const timer = Date.now();
    meshRef.current.rotation.x = timer * 0.0003;
    meshRef.current.rotation.z = timer * 0.0002;
  });

  return (
    <mesh ref={meshRef} position={[450, 0, 0]}>
      <sphereGeometry args={[175, 32, 32]} />
      <meshPhongMaterial 
        flatShading={true}
        color={0xcccccc}
        shininess={100}
      />
    </mesh>
  );
}


function AboutMe() {
  return (
   <div style={{ width: '100%', height: '80vh', overflow: 'hidden' }}>
      <Canvas camera={{ position: [0, 150, 200], fov: 70 }}   style={{ width: '100%', height: '100%' }}>
        
        <AsciiRenderer /> 
        
        <directionalLight position={[5, 5, 5]} intensity={2} />
        <directionalLight position={[-5, -5, -5]} intensity={3} />
        
        <Sphere1 />
        <Sphere2 />
      </Canvas>
      <div className="text-center div-style-3 subpage-div">
			<h2 className="mt-4" data-usal="text-fluid split-letter duration-1750 split-delay-75">About Me</h2>
          	<p className="m-4">My previous experience includes four months at SGI (Saskatchewan Government Insurance), where I was a full stack developer in a C#, React with TypeScipt environment. As well as, 
              a work term with the Government of Saskatchewan, doing configuration 
            and help desk work for 12 months.
            I have a passion for building good software and leveraging technology to solve problems. I enjoy building personal projects
            alongside my coursework. Currently exploring ThreeJS, and developing a blackjack game in C++/Lua. 
            <br></br>
            <br></br>
            Ex-university football player for the Regina Rams. In my spare time I help out coaching my old high school team. 
            Enjoy playing games, currently Deadlock. Love doing puzzles and watching sports and playing recreationally. 
          </p>
        </div>
    </div>
  );
}

export default AboutMe;